import { IAnalyticsService } from '../interfaces/IAnalyticsService';
import logger from '../loggerService';

/**
 * Web Implementation of Analytics Service
 * Proxies to logger and can be extended to support Google Analytics, Mixpanel, etc.
 */
export class WebAnalyticsService implements IAnalyticsService {
    trackEvent(name: string, properties?: Record<string, unknown>): void {
        logger.info(`[Analytics] Event: ${name}`, { ...properties, context: 'WebAnalyticsService' });
    }

    identify(userId: string, traits?: Record<string, unknown>): void {
        logger.info(`[Analytics] Identify User: ${userId}`, { ...traits, context: 'WebAnalyticsService' });
    }

    screen(name: string): void {
        logger.info(`[Analytics] Screen View: ${name}`, { context: 'WebAnalyticsService' });
    }
}
